export default __webpack_public_path__ + "static/media/rnr-sports-table-8.ab2ebf02.webp";